import { cn } from "@/lib/utils";
import { elapsedPct } from "@/lib/elapsed";

/** Linear progress of the cook against its target, red once late. */
export function ProgressBar({ seconds, targetMinutes, late }: { seconds: number; targetMinutes: number; late: boolean }) {
  const pct = elapsedPct(seconds, targetMinutes);
  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={pct}
      className="h-2 w-full overflow-hidden rounded-full bg-(--gray-200)"
    >
      <div
        className={cn("h-full rounded-full transition-[width]", late ? "bg-(--color-danger)" : "bg-(--brand-blue)")}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
